import type { ContextValue } from '../../components/SunriseHoldoutExperimentContextProvider';

import type { EnabledState } from './enabledState';
import type { VariantState } from './variantState';

import type { Props } from './index';

export const RADIO_BUTTON_VARIANTS = ['variant_1', 'variant_4'];

export type SelectionProps = {
	checked: boolean;
	isSunriseEnabled: EnabledState['isSunriseEnabled'];
};

export type SelectionState = {
	shouldHideRadioButtons: boolean;
	shouldShowSelectionBorder: boolean;
	isSunriseEnabled: EnabledState['isSunriseEnabled'];
} & VariantState;

export function isSelectionState(props: Props): props is SelectionProps {
	return !!props && ['isSunriseEnabled', 'checked'].every((prop) => prop in props);
}

export function selectionState(
	isSunriseEnabled: boolean,
	checked: boolean,
	variant: ContextValue['variant'],
): SelectionState {
	return {
		isSunriseEnabled,
		shouldHideRadioButtons: !variant || !RADIO_BUTTON_VARIANTS.includes(variant),
		shouldShowSelectionBorder: variant === 'variant_2' && !checked,
		variant,
	};
}
